export default "__VITE_ASSET__Dcril1Nc__"